import Recipient from '@/models/mailing/recipient'
import _ from 'lodash'
import sort from '@/services/sorting'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import NumberField from '@/components/Ui/ActiveForm/BZCore/Fields/NumberField'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'

import Messengers from '@/components/Recipient/table/messengers.vue'

// @ts-ignore
import messages from '@/lang/index';

const RecipientsActiveTableConfig: ActiveTableConfig<Recipient> = {
  documentsName: messages.common.recipients1,
  defaultPageSize: 10,
  onRowClick ({row}) {
    router.push({name: 'studentPage', params: {id: row.getId()}})
  },
  async find (search, filters, sortKeys, limit, offset, scope) {
    if (!scope && !scope.mailing_id) throw new Error(messages.newsletters.no_mailing_id);

    const params = {
      limit,
      offset,
      ...scope
    }

    const result = await store.dispatch('mailing/rcptFind', params)
    return {
      count: result.count,
      list: result.rcpts
    }
  },
  filtersAndActions: {
    pageName: messages.labels.search_and_filters,
    searchFormButtonText: messages.labels.search_recipients_form_button_text,
    hideFilters: true,
    searchForm: {},
    filters: {}
  },
  defaultShownColumns: ['last_name', 'first_name', 'middle_name', 'messengers'],
  table: {
    cols: {
      last_name: {label: messages.labels.cols.last_name},
      first_name: {label: messages.labels.cols.first_name},
      middle_name: {label: messages.labels.cols.middle_name},
      messengers: {label: messages.labels.cols.messengers, component: Messengers},
    }
  } as TableOptions
}
export default RecipientsActiveTableConfig
